import { ConfigurationParameters, Variant } from '../interfaces';
import { createRequestBuilder } from '@commercetools/api-request-builder';
import { makeCommerceToolsClient } from './makeCommercetoolsClient';
import { variantTransformer } from './dataTransformers';

export async function fetchVariantPreviews(
  skus: string[],
  config: ConfigurationParameters
): Promise<Variant[]> {
  if (!skus.length) {
    return [];
  }

  const client = makeCommerceToolsClient({
    parameters: { installation: config },
  });
  const requestBuilder = createRequestBuilder({
    projectKey: config.projectKey,
  });
  const uri = requestBuilder.productProjectionsSearch
    .parse({
      markMatchingVariants: true,
      filter: [`variants.sku:${skus.map((sku) => `"${sku}"`).join(',')}`],
    })
    .build();
  const response = await client.execute({ uri, method: 'GET' });

  if (response.statusCode === 200) {
    const variants: Variant[] = response.body.results[0].variants;
    const matchingVariants = variants
      .filter((variant) => variant.isMatchingVariant)
      .map(variantTransformer());

    // exception for mastervariant
    skus.forEach((sku) => {
      if (sku === response.body.results[0].masterVariant.sku) {
        matchingVariants.push({ sku: sku, image: 'n/a' });
      }
    });

    return [...matchingVariants];
  }
  throw new Error(response.statusCode);
}
